import React, { FC, HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<SVGSVGElement> {
  className?: string;
  size?: number;
  color?: string;
}

export const HorizontalHalfMoonIcon: FC<Props> = ({ className, size = 24, color = 'currentColor', ...props }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11.9998 1.99999C13.3831 1.99999 14.6831 2.2625 15.8998 2.7875C17.1164 3.3125 18.1748 4.02499 19.0748 4.92499C19.9748 5.82499 20.6873 6.88333 21.2123 8.09999C21.7373 9.31666 21.9998 10.6167 21.9998 12C21.9998 13.3833 21.7373 14.6833 21.2123 15.9C20.6873 17.1167 19.9748 18.175 19.0748 19.075C18.1748 19.975 17.1164 20.6875 15.8998 21.2125C14.6831 21.7375 13.3831 22 11.9998 22C10.6164 22 9.31642 21.7375 8.09976 21.2125C6.88309 20.6875 5.82476 19.975 4.92476 19.075C4.02476 18.175 3.31226 17.1167 2.78726 15.9C2.26226 14.6833 1.99976 13.3833 1.99976 12C1.99976 10.6167 2.26226 9.31666 2.78726 8.09999C3.31226 6.88333 4.02476 5.82499 4.92476 4.92499C5.82476 4.02499 6.88309 3.3125 8.09976 2.7875C9.31642 2.2625 10.6164 1.99999 11.9998 1.99999ZM11.9998 3.99999C9.76642 3.99999 7.87476 4.77499 6.32476 6.32499C4.77476 7.87499 3.99976 9.76666 3.99976 12H11.9998L19.9998 12C19.9998 9.76666 19.2248 7.87499 17.6748 6.32499C16.1248 4.77499 14.2331 3.99999 11.9998 3.99999Z" />
    </svg>
  );
};
